//@ts-check
import React, { useEffect } from 'react';
import fieldsLogic from '../logic/fieldsLogic';
import useFormOptions from '../context/useFormOptions';
import useFormDataLayer from '../logic/useFormDataLayer';
import FormField from './Field';
import GoogleAddress from '../fields/GoogleAddress';
import api from './GoogleMaps';

var ConnectedGoogleAddressField = function ConnectedGoogleAddressField(_ref) {
  var fieldId = _ref.fieldId,
      variant = _ref.variant,
      xpath = _ref.xpath,
      lookupVisiblity = _ref.lookupVisiblity;
  var fieldData = useFormDataLayer(fieldId);
  var caption = fieldData.caption,
      labelPlacement = fieldData.labelPlacement,
      required = fieldData.required;
  var value = fieldData.value,
      dispatch = fieldData.dispatch,
      error = fieldData.error,
      readonly = fieldData.readonly,
      active = fieldData.active;

  var _useFormOptions = useFormOptions(),
      googleAPIKey = _useFormOptions.googleAPIKey;

  var googleApiState = api.useGoogleAPI(googleAPIKey);

  var onChange = function onChange(newAddress) {
    fieldsLogic.onChange(fieldId, newAddress, dispatch);
  };

  var onFocus = function onFocus() {
    return fieldsLogic.onFocus(fieldId, dispatch);
  };

  var onBlur = function onBlur() {
    return fieldsLogic.onBlur(fieldId, dispatch);
  };

  useEffect(function () {
    if (googleApiState.loading) return;
    if (value !== undefined) return;
    if (!navigator || !navigator.geolocation) return;
    api.getCurrentAddress(googleApiState.google).then(function (address) {
      onChange(address);
    }, function (error) {} // do nothing yet
    );
  }, [value, googleApiState]);
  return React.createElement(FormField, {
    label: caption,
    labelPlacement: labelPlacement || 'left',
    required: required
  }, !googleApiState.loading && React.createElement(GoogleAddress, {
    active: active,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    apiKey: googleAPIKey,
    address: value || '',
    error: error,
    readonly: readonly,
    variant: variant,
    xpath: xpath,
    lookupVisiblity: lookupVisiblity,
    fieldId: fieldId
  }));
};

export default React.memo(ConnectedGoogleAddressField);